import React, { useEffect, useState } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import NFTSection from './components/NFTSection';
import About from './components/About';
import Tech from './components/Tech';
import CommunityOperatingSystem from './components/CommunityOperatingSystem';
import FAQ from './components/FAQ';
import Community from './components/Community';
import Footer from './components/Footer';
// import PasswordGate from './components/PasswordGate'; // REMOVED: Password protection disabled November 1, 2025
import LaunchBanner from './components/LaunchBanner';
import './App.css';

const App: React.FC = () => {
  const [isTeamModalOpen, setIsTeamModalOpen] = useState(false);

  // Effect for PWA setup and initialization
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((registration) => {
            void registration.unregister();
          });
        });
      }
    } else if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').then(
          (registration) => {
            console.log('ServiceWorker registration successful with scope: ', registration.scope);
          },
          (err) => {
            console.log('ServiceWorker registration failed: ', err);
          }
        );
      });
    }

    // Set page title
    document.title = 'BornFree | Freedom Reimagined';
    
    // Add meta description
    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = 'BornFree is a community actively creating intentional NFTs. Join us to build the future with blockchain technology and community governance.';
    document.head.appendChild(metaDescription);
    
    // Clean up function
    return () => {
      const existingMeta = document.querySelector('meta[name="description"]');
      if (existingMeta) {
        existingMeta.remove();
      }
    };
  }, []);

  return (
    <>
      {/* Launch Banner - Remove after November 11, 2025 */}
      <LaunchBanner />
      
      <div className="app min-h-screen flex flex-col">
        {/* Navigation */}
        <Navigation />
      
      {/* Main Content - Single Page Layout - z-10 so it stacks above footer (z-0) and doesn't get covered when scrolling */}
      <main 
        className="flex-grow bg-black relative z-10" 
        style={{
          backgroundImage: `url('/images/fractals-2042298_1920.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          backgroundRepeat: 'no-repeat',
          minHeight: '100vh'
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10">
          <Hero 
            isMember={false} // TODO: Connect to actual membership check
            videos={[
              {
                id: '1',
                title: 'Platform Overview',
                youtubeId: 'U9hkNezNrL0',
                description: 'Learn how BornFree works in 60 seconds'
              },
              {
                id: '2',
                title: 'How to Sign Up',
                youtubeId: 'VhCNgYFHgFk',
                description: 'Step-by-step guide to becoming a member'
              },
              {
                id: '3',
                title: 'Using NFTs & Credits',
                youtubeId: 'CEH4MeNdpks',
                description: 'Master the credit system and reservations'
              },
              {
                id: '4',
                title: 'BornFree Tutorial',
                youtubeId: 'NIt6-PBIyoo',
                description: 'Complete guide to the platform'
              }
            ]}
            showVideoGallery={true}
          />
          <NFTSection />
          <About />
          <Community isTeamModalOpen={isTeamModalOpen} setIsTeamModalOpen={setIsTeamModalOpen} />
          <Tech />
          <CommunityOperatingSystem />
          <FAQ onTeamModalOpen={() => setIsTeamModalOpen(true)} />
        </div>
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
    </>
  );
};

export default App;
